import { Link } from "react-router-dom";
import Layout from "../components/site/Layout";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <Layout>
      <Seo
        title="Page Not Found (404) | EPS Viewer"
        description="The page you were looking for could not be found. Open the EPS Viewer or browse our guides."
        noindex
      />
      <section className="section">
        <div className="container section-head--center" style={{ maxWidth: 620 }}>
          <span className="eyebrow">404</span>
          <h1 className="section-title">We couldn&apos;t find that page</h1>
          <p className="section-lead">
            The page you&apos;re looking for may have moved or no longer exists.
            Here are some helpful places to go instead:
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 20 }}>
            <Link to="/" className="btn btn--primary">Open the EPS Viewer</Link>
            <Link to="/guides" className="btn btn--ghost">Browse guides</Link>
            <Link to="/faq" className="btn btn--ghost">FAQ</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
